export default "__VITE_ASSET___IOK7cSG__"